<template>
    <div class="page-main">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
            <div class="right-bar">
                <div class="right-mian_active">
                    <input placeholder="请输入作业名称、布置人" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch"/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-main-wrap">
            <div class="table-main">
                <div class="table-content">
                    <div class="header">
                        <Col :span="2">
                        <span>序号</span>
                        </Col>
                        <Col :span="4">
                        <span>学校名称</span>
                        </Col>
                        <Col :span="4">
                        <span>作业名称</span>
                        </Col>
                        <Col :span="4">
                        <span>布置人</span>
                        </Col>
                        <Col :span="5">
                        <span>布置时间</span>
                        </Col>
                        <Col :span="5">
                        <span>学科</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in homeworkList" v-if="homeworkList.length>0">
                            <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                <Col :span="2" class="col-content">
                                <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.schoolName==='' ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <!--<span>{{item.workTitle==='' ? '暂无':item.workTitle}}</span>-->
                                <template v-if="item.workTitle===''">
                                    <span>暂无</span>
                                </template>
                                <template v-else>
                                    <a :title="item.workTitle" href="javascript:void(0);"
                                       v-on:click="lookWorkReport(item.teaId,item.workId,item.workTitle,item.hwType,item.hwTypeCode)"
                                       style="color: #2d8cf0;">{{item.workTitle}}</a>
                                </template>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.displayName ==='' ? '暂无':item.displayName}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.create_time ==='' ? '暂无':item.create_time}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.bankName ==='' ? '暂无':item.bankName}}</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="homeworkList.length===0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findHomeWorkList} from "../../../../service/api.js";
    import {mapGetters} from 'vuex'

    export default {
        name: "homework-list",
        computed: {
            ...mapGetters([
                'homeWorkReportPath'
            ]),
        },
        data () {
            return {
                homeworkList: [],
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 0,
                    keyWord: '',
                    startDate: '',
                    endDate: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                }
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部作业",
                    path: "",
                    name: "homeworkList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 获取资源列表
             */
            async getHomeworkList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findHomeWorkList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.homeworkList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                this.getHomeworkList();
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getHomeworkList();
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                let todayStr = this.$utils.getTodayStr();
                //反选的情况
                if (this.filters.timeSolt === type) {
                    this.filters.timeSolt = 0;
                    this.filters.startDate = '';
                    this.filters.endDate = '';
                } else {
                    this.filters.timeSolt = type;
                    this.filters.endDate = todayStr + ' 23:59:59';
                }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    // this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    // this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';

                    this.filters.startDate = this.$utils.getSevenDayStr() + ' 00:00:00';

                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    // this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    // this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';

                    this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 1) + ' 00:00:00';

                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    // this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    // this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';

                    this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 12) + ' 00:00:00';
                }
                this.handleSearch();
            },
            /**
             * 点击查看作业报告
             */
            lookWorkReport (userId, homeworkId, homeworkName, hwType,hwTypeCode) {
                let reportUrl = "";
                //答题卡
                if (hwType == 0) {
                    // reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/dashboard';
                    reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web';
                } else if (hwType == 1) {
                    if(hwTypeCode=='103'){
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/pc';
                    }else{
                        //题库
                        reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web';
                    }
                }
                window.open(reportUrl, "_blank");
            }
        },
        mounted () {
            this.getHomeworkList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";
</style>
